import React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Collapse from "react-bootstrap/Collapse";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";
import reportAction from "../../../store/actions/reportAction";
import eventAdvertise from "../../../store/actions/eventAdvertise";

const HeaderReport = ({
  dateFrom,
  dateTo,
  separation,
  setSitePublisherID,
  getReportWebSitePublisher,
  getReportWebSitePublisherDataChart,
  getReportAllWebSitePublisher,
  getReportAllWebSitePublisherDataChart,
  getReportWebSitePublisherDataChartSeparation,
  getReportAllWebSitePublisherDataChartSeparation,
}) => {
  const eventReport = eventAdvertise.eventAdvertiseString.VIEW;
  const [open, setOpen] = useState(false);
  const [allUserSitePublishers, setAllUserSitePublishers] = useState([]);

  useEffect(() => {
    getAllUserSitePublishers();
  }, []);

  const getAllUserSitePublishers = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allUserSitePublishers = await sendRequestGetAllUserSitePublishers();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allUserSitePublishers) {
      return;
    }
    setAllUserSitePublishers(allUserSitePublishers);
  };

  const sendRequestGetAllUserSitePublishers = async () => {
    const headersRequest = getHeaderRequest();
    let allUserSitePublishers;
    try {
      allUserSitePublishers = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/site",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allUserSitePublishers.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const clickSitePublisherHandler = (e, sitePublisherID) => {
    changeNameItemReport(e.currentTarget.textContent);
    const parentCollapsedTag = document.querySelector(
      "#" + e.currentTarget.parentNode.parentNode.id
    );
    parentCollapsedTag.classList.add("show");
    removeLastBgPrimaryClassTag();
    addClassBgPrimaryToTag(e);
    closeDropDownSelectCampaign();
    setSitePublisherID({
      site_publisher_ID: sitePublisherID,
    });
    getReportWebSitePublisher({
      site_publisher_ID: sitePublisherID,
      date_from: dateFrom,
      date_to: dateTo,
    });
    getReportWebSitePublisherDataChart({
      sitePublisherID,
      dateFrom,
      dateTo,
      eventReport,
    });
    getReportWebSitePublisherDataChartSeparation({
      sitePublisherID,
      dateFrom,
      dateTo,
      separation,
    });
  };

  const changeNameItemReport = (nameItemReport) => {
    document.querySelector("#name-item-report").textContent = nameItemReport;
  };

  const closeDropDownSelectCampaign = () => {
    document
      .querySelector(".dropdown-menu.drop-down-select-campaign")
      .classList.remove("show");
  };

  const removeLastBgPrimaryClassTag = () => {
    document
      .querySelector(".drop-down-select-campaign .bg-success")
      .classList.remove("bg-success");
  };

  const addClassBgPrimaryToTag = (e) => {
    e.currentTarget.classList.add("bg-success");
  };

  return (
    <div
      id="name-campaigns"
      className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-1"
    >
      <div className="p-2 d-flex align-items-center justify-content-between">
        <span id="name-item-report" className="text-dark">
          همه سایت
        </span>
        <span id="container-dropdown-select-campaign-report">
          <div className="dropdown ">
            <button
              className="btn dropdown-toggle text-dark"
              type="button"
              id="drop-down-button-select-campaign"
              data-toggle="dropdown"
              aria-haspopup="false"
              aria-expanded="false"
            >
              همه سایت
            </button>
            <div
              className="dropdown-menu drop-down-select-campaign py-0 my-0 border-success border-bottom-0"
              style={{ width: "300px" }}
              aria-labelledby="drop-down-button-select-campaign"
            >
              <div className="d-flex flex-column border-radius-drop-down-select-campaign">
                <span
                  className="py-2 pr-2 bg-success border-success border-bottom text-right hover border-radius-top-drop-down-select-campaign "
                  onClick={(e) => {
                    removeLastBgPrimaryClassTag();
                    addClassBgPrimaryToTag(e);
                    changeNameItemReport(e.currentTarget.textContent);
                    getReportAllWebSitePublisher({
                      dateFrom,
                      dateTo,
                    });
                    getReportAllWebSitePublisherDataChart({
                      dateFrom,
                      dateTo,
                      eventReport,
                    });
                    getReportAllWebSitePublisherDataChartSeparation({
                      dateFrom,
                      dateTo,
                    });
                  }}
                >
                  <span className="text-dark text-right">همه سایت</span>
                </span>

                <div>
                  <div
                    className="card-header pr-2 py-2 m-0 border-success rounded-0"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpen(!open);
                    }}
                    aria-controls="accordion-body-all-campaign-banner"
                    aria-expanded={open}
                  >
                    <div className="mb-0">
                      <div className=" d-flex hover  justify-content-between ">
                        <span className="text-dark text-right">
                          لیست سایت های نمایش دهنده
                        </span>
                        <span>
                          <i
                            id="header-banner-accordion-icon"
                            className={`fa fa-angle-${open ? "down" : "left"}`}
                            aria-hidden="true"
                          ></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <Collapse in={open}>
                  <div id="accordion-body-all-campaign-banner">
                    <div className="card-body p-0 ">
                      {allUserSitePublishers.length > 0 &&
                        allUserSitePublishers.map((sitePublisher) => {
                          return (
                            <div
                              onClick={(e) => {
                                clickSitePublisherHandler(e, sitePublisher.id);
                              }}
                              className="py-2 pl-2 text-left hover border-success border-bottom"
                            >
                              <span className="text-dark  ">
                                {sitePublisher.url.replace("https://", "")}
                              </span>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSitePublisherID: (action) => {
      dispatch({
        type: reportAction.SET_SITE_PUBLISHER_ID,
        payload: action,
      });
    },
    getReportWebSitePublisher: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER,
        payload: action,
      });
    },
    getReportAllWebSitePublisher: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER,
        payload: action,
      });
    },
    getReportAllWebSitePublisherDataChart: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART,
        payload: action,
      });
    },
    getReportWebSitePublisherDataChart: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART,
        payload: action,
      });
    },
    getReportWebSitePublisherDataChartSeparation: (action) => {
      dispatch({
        type: reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART,
        payload: action,
      });
    },
    getReportAllWebSitePublisherDataChartSeparation: (action) => {
      dispatch({
        type: reportAction.GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART,
        payload: action,
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    dateFrom: state.report.date_from,
    dateTo: state.report.date_to,
    whichTypeSelect: state.report.which_type_select,
    separation: state.report.separation_data_chart,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderReport);
